import React from 'react';
import { BriefcaseBusinessIcon, FilePenLineIcon, FileTextIcon, GavelIcon, LandmarkIcon, ScaleIcon } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function Tomos() {
  const modules = [{
    icon: LandmarkIcon,
    title: 'Modernización Laboral 2026',
    items: ['Ley 27.802', 'Normativa', 'Decretos reglamentarios', 'Doctrina y aplicación práctica']
  }, {
    icon: FilePenLineIcon,
    title: 'Contratos Laborales',
    items: ['Contratos editables', 'Cláusulas', 'Acuerdos', 'Anexos y documentación laboral']
  }, {
    icon: FileTextIcon,
    title: 'Demandas y Escritos Judiciales',
    items: ['Demandas', 'Contestaciones', 'Recursos', 'Excepciones e incidentes']
  }, {
    icon: ScaleIcon,
    title: 'Telegramas y Desvinculaciones',
    items: ['Despidos', 'Renuncias', 'Intimaciones', 'Liquidaciones y acuerdos']
  }, {
    icon: GavelIcon,
    title: 'Litigación Estratégica',
    items: ['Medidas cautelares', 'Producción de prueba', 'Audiencias', 'Estrategias procesales']
  }, {
    icon: BriefcaseBusinessIcon,
    title: 'Jurisprudencia y Herramientas',
    items: ['Fallos', 'Doctrina', 'Checklists y formularios', 'Protocolos de consulta']
  }];
  return <section className="px-5 py-14 md:px-8 md:py-20" data-id="element-182" data-mp="3sepu0zve6vw3">
      <div className="mx-auto max-w-6xl" data-id="element-183" data-mp="1a9digxqrl8b">
        <FadeIn className="text-center" data-id="element-184" data-mp="1aj2q2aypocy">
          <p className="text-sm font-bold uppercase tracking-[0.18em] text-accent" data-id="element-185" data-mp="692nhzdtku3q">
            Contenido integral
          </p>
          <h2 className="mt-2 font-display text-3xl font-bold text-white md:text-4xl" data-id="element-186" data-mp="2325y0g1w05f8">
            6 Módulos Profesionales listos para aplicar
          </h2>
        </FadeIn>

        <div className="mt-10 grid gap-4 md:grid-cols-2 lg:grid-cols-3" data-id="element-187" data-mp="1zzhwwrezvcut">
          {modules.map(({
          icon: Icon,
          title,
          items
        }, index) => <FadeIn key={title} delay={index * 0.05} data-id="element-188" data-mp="1vzhhp4k2mxmp" data-mpi={index}>
              <article className="h-full border border-white/10 bg-charcoal p-6" data-id="element-189" data-mp="29xnx94l5kaxk">
                <div className="flex items-center gap-3" data-id="element-190" data-mp="29vkynw5xp9h8">
                  <Icon size={24} className="text-accent" strokeWidth={1.6} aria-hidden="true" data-id="element-191" data-mp="24y2zgxhpy8mf" />
                  <span className="text-xs font-bold uppercase tracking-[0.16em] text-stone-500" data-id="element-192" data-mp="2ew8yn7c550nl">
                    Módulo {index + 1}
                  </span>
                </div>
                <h3 className="mt-5 font-display text-xl font-bold text-white" data-id="element-193" data-mp="2np2i7gymem79">
                  {title}
                </h3>
                <ul className="mt-4 space-y-2" data-id="element-194" data-mp="32n4ldq1qp5nz">
                  {items.map(item => <li key={item} className="flex gap-2 text-sm text-stone-300" data-id="element-195" data-mp="2xotadbzpkp46">
                      <span className="text-accent" aria-hidden="true" data-id="element-196" data-mp="3lawxm5iqsyrd">
                        —
                      </span>
                      {item}
                    </li>)}
                </ul>
              </article>
            </FadeIn>)}
        </div>

        <div className="mt-8 border-l-2 border-accent bg-charcoal px-5 py-4 text-center" data-id="element-197" data-mp="3cc1uj2azw4sa">
          <p className="font-semibold text-white" data-id="element-198" data-mp="2xj81sf6pps5o">
            Más de 600 páginas de contenido profesional.
          </p>
          <p className="mt-1 text-sm text-stone-400" data-id="element-199" data-mp="2okmjml55kf5f">
            Material listo para copiar, adaptar y utilizar en tu práctica.
          </p>
        </div>
      </div>
    </section>;
}